import classNames from "classnames"
import React from "react"
import styled from "styled-components"

const TabsStyled = styled.div`

    .custom-tab-panel-hidden {
        display: none;
    }
    .custom-tab-list {
        position: relative;
    }
    .custom-tab-list-item {
        width: 116px;
        height: 40px;

        border-radius: 8px 8px 0px 0px;
        color: #333;
        font-size: 14px;
        color: #213130;
        font-weight: bold;

        &-active {
            background: #FFFFFF;
        }
    }
`

// Tabs 组件
const Tabs = ({ children, value, onChange, className, style }) => {
    const passProps = { activeTab: value, onChange }
    return (
        <TabsStyled className={className} style={style}>
            {React.Children.map(children, (child) =>
                React.cloneElement(child, passProps)
            )}
        </TabsStyled>
    )
}

// TabList 组件
const TabList = ({ children, activeTab, onChange }) => {
    const passProps = { activeTab, onChange }
    return <div className="flex custom-tab-list">
        {React.Children.map(children, (child) =>
            React.cloneElement(child, passProps)
        )}
    </div>
}

// Tab 组件
const Tab = ({ children, value, activeTab, onChange }) => {
    const cls = classNames('flex-center custom-tab-list-item', {'custom-tab-list-item-active': activeTab === value})
    return (
        <div
            className={cls}
            onClick={() => onChange && onChange(value)}
        >
            {children}
        </div>
    )
}

// TabPanel 组件
const TabPanel = ({ children, value, activeTab }) => {
    const cls = classNames('custom-tab-panel', {'custom-tab-panel-hidden': activeTab !== value})
    return <div className={cls}>{children}</div>
}

Tabs.List = TabList;
Tabs.Tab = Tab;
Tabs.Panel = TabPanel;


export default Tabs